export const environment = {
  name: 'develop',
  production: false,
  enableClarity: false,
  clarityId: '',
  sentryDsn: 'https://b83a88e4d9b50ce605e0cf90d8d95fb8@o1036057.ingest.us.sentry.io/4510759351681024',
  apiUrl: 'https://api-direct.dev.docestate.com',
  paymentsApiUrl: 'https://payment-api.dev.docestate.com',
  iframeConfigId: '8aaeb966-a0a7-4bc8-bc1c-974d261a349c',
  productCatalogueId: '927be673-a099-42bd-acad-b728cd8583f3',
  stripe: {
    publicKey: 'pk_test_51JIryUC7AZQFnsXP9eHjLCDNoT5CTMR2UqmEfmhR1fpCUFm0LFCe2VsEtO9QP33HoyXQo6my4oiDXYCAoJBZzkx400HLUXZZW7',
    paymentMethodConfigurationId: 'pmc_1SzJF7C7AZQFnsXPfIBJf6ST'
  },
  host: 'https://direct.dev.docestate.com/',
  mapUrl: 'https://maps.dev.docestate.com?searchBarAboveMap=true&requireValidAddressForParcelSelection=true',
  realm: 'DocEstateDev',
  userInfoEndpoint: 'https://authentication.dev.docestate.com/realms/DocEstateDev/protocol/openid-connect/userinfo',
  tokenEndpoint: 'https://authentication.dev.docestate.com/realms/DocEstateDev/protocol/openid-connect/token',
  loginUrl: 'https://authentication.dev.docestate.com/realms/DocEstateDev/protocol/openid-connect/auth',
  clientId: 'DIRECT_BOOKING_FRONTEND',
  docuSeal: {
    directAuthority: 'https://docuseal.eu/d/PDA3kVwzTqfcsA',
    subAuthority: 'https://docuseal.eu/d/oyWkJiG3Ly7Pc7',
  },
};
